<template>
  <div>
    <slot v-bind="countDownDate"></slot>
  </div>
</template>

<script>
export default {
  props: ['start', 'end', 'server'],
  data() {
    return {
      currentTime: 0,
      // 倒计时相关
      countDownDate: {
        days: '00', // 距离结束时日
        hours: '00', // 距离结束时时
        minutes: '00', // 距离结束时分
        seconds: '00' // 距离结束时秒
      }
    }
  },
  computed: {
    // 开始时间
    startTime() {
      let startDate
      if (typeof this.start === 'string')
        startDate = this.start.replace(/-/g, '/')
      if (typeof this.start === 'number') startDate = this.start
      return new Date(startDate).getTime()
    },
    // 结束时间
    endTime() {
      let endDate
      if (typeof this.end === 'string') endDate = this.end.replace(/-/g, '/')
      if (typeof this.end === 'number') endDate = this.end
      return new Date(endDate).getTime()
    },
    // 当前活动状态
    // coming : 未开始
    // start : 开始
    // end : 结束
    status() {
      if (this.server < this.startTime) {
        return 'coming'
      } else if (this.server >= this.startTime && this.server <= this.endTime) {
        return 'start'
      } else if (this.server > this.endTime) {
        return 'end'
      }
      return ''
    }
  },
  methods: {
    // 设置倒计时
    countDown() {
      this.currentTime = this.server
      if (this.status === 'end') {
        return
      }
      let timers
      if (this.status === 'start') {
        timers = this.getRemainTime(this.endTime, this.currentTime)
      } else {
        timers = this.getRemainTime(this.startTime, this.currentTime)
      }
      this.countDownDate = timers
      this.$emit('update', this.server + 1000)
      this.timer = setTimeout(() => {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.countDown()
      }, 1000)
    },
    getRemainTime(endTime, serverTime) {
      let t =
        (typeof endTime === 'number' ? endTime : Date.parse(endTime)) -
        (typeof serverTime === 'number' ? serverTime : Date.parse(serverTime))

      let seconds = Math.floor((t / 1000) % 60)
      let minutes = Math.floor((t / 1000 / 60) % 60)
      let hours = Math.floor((t / (1000 * 60 * 60)) % 24)
      let days = Math.floor(t / (1000 * 60 * 60 * 24))

      return {
        total: t,
        days: days > 9 ? days + '' : `0${days}`,
        hours: hours > 9 ? hours + '' : `0${hours}`,
        minutes: minutes > 9 ? minutes + '' : `0${minutes}`,
        seconds: seconds > 9 ? seconds + '' : `0${seconds}`
      }
    }
  }
}
</script>
